module.exports = __webpack_public_path__ + "img/illu-eco.9790be6d.svg";